import React, { Suspense, useEffect } from 'react';
import { connect } from 'react-redux';
import { Route, Router, Switch, Redirect } from 'react-router-dom';
import { func, bool } from 'prop-types';
import { ThemeProvider } from '@mui/material/styles';

import { createTheme } from 'theme';
import CustomerSupport from 'views/CustomerSupport';
import SupportTicket from 'views/CustomerSupport/SupportTicket';
import SupportTIcketUpdate from 'views/CustomerSupport/TicketUpdate';
import Dashboard from 'layouts/Dashboard';
import Ecosystems from 'layouts/Ecosystems';
import Organizations from 'layouts/Organizations';
import Login from 'layouts/Login';

import { ROUTES } from './enum';
import history from './history';
import GlobalLoader from './components/GlobalLoader';
import ProtectedRoute from './components/ProtectedRoute';
import FetchErrorMessage from './components/FetchErrorMessage';
import NotFound from './views/NotFound';
import UserProfile from './views/Profiles';
import EcosystemDetail from './views/EcosystemDetail';
import { startup } from './store/common-scenario-actions';
import { isAuthenticatedSelector } from './store/user/selectors';

const App = ({ startup, startupFinished, isAuthenticated }) => {
  useEffect(() => {
    startup();
  }, [startup]);

  return (
    <Suspense>
      <ThemeProvider theme={createTheme()}>
        <FetchErrorMessage />
        {startupFinished ? (
          <Router history={history}>
            <Switch>
              <ProtectedRoute exact path={ROUTES.CUSTOMERS} component={Organizations} />
              <ProtectedRoute exact path={`${ROUTES.CUSTOMER_SUPPORT}/:cusID`} component={CustomerSupport} />
              <ProtectedRoute exact path={`${ROUTES.CUSTOMER_SUPPORT}/:cusID/new`} component={SupportTicket} />
              <ProtectedRoute
                exact
                path={`${ROUTES.CUSTOMER_SUPPORT}/:cusID/ticket/:ticketId`}
                component={SupportTIcketUpdate}
              />
              <ProtectedRoute exact path={`${ROUTES.CUSTOMERS}/:cusID/ecosystems`} component={Ecosystems} />
              <ProtectedRoute exact path={`${ROUTES.CUSTOMERS}/:cusID/ecosystems/dashboard`} component={Ecosystems} />
              <ProtectedRoute
                exact
                path={`${ROUTES.CUSTOMERS}/:cusID/ecosystems/threat-report`}
                component={Ecosystems}
              />
              <ProtectedRoute
                exact
                path={`${ROUTES.CUSTOMERS}/:cusID/ecosystems/dashboard/:ecoID`}
                component={EcosystemDetail}
              />
              <ProtectedRoute path={`${ROUTES.CUSTOMERS}/:cusID/ecosystems/:ecoID`} component={Dashboard} />
              <ProtectedRoute exact path={ROUTES.PROFILE} component={UserProfile} />
              <Redirect exact from="/" to={ROUTES.CUSTOMERS} />
              <Redirect exact from="/v1" to={ROUTES.CUSTOMERS} />
              <Redirect exact from={`${ROUTES.CUSTOMERS}/:cusID`} to={`${ROUTES.CUSTOMERS}/:cusID/ecosystems`} />
              <Route path="/v1/auth" component={Login} />
              <Route path={ROUTES.NOT_FOUND} component={NotFound} />
              <Route path="*" component={!isAuthenticated ? Login : NotFound} />
            </Switch>
          </Router>
        ) : (
          <GlobalLoader />
        )}
      </ThemeProvider>
    </Suspense>
  );
};

App.propTypes = {
  startup: func.isRequired,
  startupFinished: bool.isRequired,
  isAuthenticated: bool,
};

const mapStateToProps = (state) => ({
  startupFinished: state.global.startupFinished,
  isAuthenticated: isAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  startup: () => dispatch(startup()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
